// Generated by Melange

import * as $$BigInt from "./BigInt.mjs";
import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.mjs";
import * as Caml_obj from "melange.js/caml_obj.mjs";
import * as Caml_option from "melange.js/caml_option.mjs";
import * as Curry from "melange.js/curry.mjs";
import * as Js__Js_nullable from "melange.js/js_nullable.mjs";
import * as LindenAPI from "./LindenAPI.mjs";
import * as Melange__RegexRender from "./RegexRender.mjs";
import * as Stdlib__Array from "melange/array.mjs";
import * as Stdlib__List from "melange/list.mjs";
import * as Stdlib__Option from "melange/option.mjs";
import * as Stdlib__String from "melange/string.mjs";
import * as Warblre_js__JsEngineParameters from "warblre-engines.js/JsEngineParameters.mjs";

function same(action, regex) {
  switch (action.TAG) {
    case /* Areg */ 0 :
      const ar = action._0;
      if (/* tag */ typeof ar === "number" || typeof ar === "string" || !(ar.TAG === /* Quantified0 */ 3 && !(/* tag */ typeof regex === "number" || typeof regex === "string" || regex.TAG !== /* Quantified0 */ 3))) {
        return ar === regex;
      } else {
        return ar._3 === regex._3;
      }
    case /* Acheck */ 1 :
      return false;
    case /* Aclose */ 2 :
      if (/* tag */ typeof regex === "number" || typeof regex === "string" || regex.TAG !== /* Group0 */ 5) {
        return false;
      } else {
        return Curry._1($$BigInt.equal(regex._0), action._0);
      }
  }
}

function regex_id_of(idMap, _acts) {
  while (true) {
    const acts = _acts;
    if (!acts) {
      return;
    }
    const a = acts.hd;
    switch (a.TAG) {
      case /* Acheck */ 1 :
        _acts = acts.tl;
        continue;
      case /* Areg */ 0 :
      case /* Aclose */ 2 :
        break;
    }
    return Stdlib__Option.map((function (prim) {
      return prim[1];
    }), Stdlib__List.find_opt((function (param) {
      return same(a, param[0]);
    }), idMap));
  };
}

function same_regex(r0, r1) {
  if (/* tag */ typeof r0 === "number" || typeof r0 === "string" || !(r0.TAG === /* Quantified0 */ 3 && !(/* tag */ typeof r1 === "number" || typeof r1 === "string" || r1.TAG !== /* Quantified0 */ 3))) {
    return r0 === r1;
  } else if (r0._0 === r1._0 && Caml_obj.caml_equal(r0._1, r1._1) && Caml_obj.caml_equal(r0._2, r1._2)) {
    return r0._3 === r1._3;
  } else {
    return false;
  }
}

function same_action(a0, a1) {
  switch (a0.TAG) {
    case /* Areg */ 0 :
      switch (a1.TAG) {
        case /* Areg */ 0 :
          return same_regex(a0._0, a1._0);
        case /* Acheck */ 1 :
        case /* Aclose */ 2 :
          return false;
      }
    case /* Acheck */ 1 :
      switch (a1.TAG) {
        case /* Acheck */ 1 :
          return Caml_obj.caml_equal(a0._0, a1._0);
        case /* Areg */ 0 :
        case /* Aclose */ 2 :
          return false;
      }
    case /* Aclose */ 2 :
      switch (a1.TAG) {
        case /* Areg */ 0 :
        case /* Acheck */ 1 :
          return false;
        case /* Aclose */ 2 :
          return Curry._1($$BigInt.equal(a0._0), a1._0);
      }
  }
}

function same_actions(_acts0, _acts1) {
  while (true) {
    const acts1 = _acts1;
    const acts0 = _acts0;
    if (!acts0) {
      if (acts1) {
        return false;
      } else {
        return true;
      }
    }
    if (!acts1) {
      return false;
    }
    if (!same_action(acts0.hd, acts1.hd)) {
      return false;
    }
    _acts1 = acts1.tl;
    _acts0 = acts0.tl;
    continue;
  };
}

function same_match_state(param, param$1) {
  if (Caml_obj.caml_equal(param[0], param$1[0]) && Caml_obj.caml_equal(param[1], param$1[1])) {
    return same_actions(param[2], param$1[2]);
  } else {
    return false;
  }
}

function quote_char(s) {
  return "‘" + (s + "’");
}

function quote_str(s) {
  return "“" + (s + "”");
}

function dir_str(param) {
  if (param === /* Forward */ 0) {
    return "Forward";
  } else {
    return "Backward";
  }
}

function lk_name(param) {
  switch (param) {
    case /* LookAhead */ 0 :
      return "LookAhead";
    case /* LookBehind */ 1 :
      return "LookBehind";
    case /* NegLookAhead */ 2 :
      return "NegLookAhead";
    case /* NegLookBehind */ 3 :
      return "NegLookBehind";
  }
}

function group_label(g) {
  switch (g.TAG) {
    case /* Open */ 0 :
      return [
        "Open",
        $$BigInt.to_string(g._0)
      ];
    case /* Close */ 1 :
      return [
        "Close",
        $$BigInt.to_string(g._0)
      ];
    case /* Reset */ 2 :
      return [
        "Reset",
        "{" + (Stdlib__String.concat(", ", Stdlib__List.map($$BigInt.to_string, g._0)) + "}")
      ];
  }
}

function fail_label(param) {
  if (param) {
    const match = param.hd;
    switch (match.TAG) {
      case /* Areg */ 0 :
        const cd = match._0;
        if (!/* tag */ (typeof cd === "number" || typeof cd === "string")) {
          switch (cd.TAG) {
            case /* Character */ 0 :
              return [
                "Read ",
                Melange__RegexRender.Pp.cd_text(cd._0)
              ];
            case /* Anchor */ 6 :
              return [
                "Anchor ",
                Melange__RegexRender.Pp.anchor_text(cd._0)
              ];
            case /* Backreference */ 7 :
              return [
                "BackRef ",
                "\\" + $$BigInt.to_string(cd._0)
              ];
          }
        }
        break;
      case /* Acheck */ 1 :
        return [
          "Progress",
          ""
        ];
      case /* Aclose */ 2 :
        break;
    }
  }
  throw new Caml_js_exceptions.MelangeError("Assert_failure", {
      MEL_EXN_ID: "Assert_failure",
      _1: [
        "TreeConvert.ml",
        85,
        9
      ]
    });
}

function state_js(input, a) {
  const match = a.inp;
  const group = function (param) {
    const r = param[1];
    return {
      id: $$BigInt.to_int(param[0]),
      startIdx: $$BigInt.to_int(r.startIdx),
      endIdx: Js__Js_nullable.fromOption(Stdlib__Option.map($$BigInt.to_int, r.endIdx))
    };
  };
  return {
    idx: Stdlib__List.length(match._1),
    input: input,
    dir: dir_str(a.dir),
    groups: Stdlib__Array.of_list(Stdlib__List.map(group, Curry._1(LindenAPI.GroupMap.MapS.$$this, a.gm)))
  };
}

function unwrap(_default, _bare) {
  while (true) {
    const bare = _bare;
    const $$default = _default;
    if (/* tag */ typeof bare === "number" || typeof bare === "string") {
      return [
        $$default,
        bare
      ];
    }
    if (bare.TAG !== /* Annot */ 8) {
      return [
        $$default,
        bare
      ];
    }
    _bare = bare._1;
    _default = bare._0;
    continue;
  };
}

function check_seen(seen, acts, pre) {
  const key_0 = pre.idx;
  const key_1 = pre.dir;
  const key = [
    key_0,
    key_1,
    acts
  ];
  const was_seen = Stdlib__List.exists((function (param) {
    return same_match_state(key, param);
  }), seen.contents);
  if (!was_seen) {
    seen.contents = {
      hd: key,
      tl: seen.contents
    };
  }
  return was_seen;
}

function to_node(idMap, input, seen, parent_redundant, $$default, ghostDepth, t) {
  const match = unwrap($$default, t);
  const tree_node = match[1];
  const ann = match[0];
  const pre = state_js(input, ann);
  const regex_id = regex_id_of(idMap, ann.acts);
  const redundant = parent_redundant || ann !== $$default && check_seen(seen, ann.acts, pre);
  const make = function (resultOpt, hasGhostSubtreeOpt, name, arg, subjs) {
    const result = resultOpt !== undefined ? Caml_option.valFromOption(resultOpt) : null;
    const hasGhostSubtree = hasGhostSubtreeOpt !== undefined ? hasGhostSubtreeOpt : false;
    const loop = function (param, param$1) {
      return to_node(idMap, input, seen, redundant, ann, param, param$1);
    };
    const children = subjs ? ({
        hd: loop(ghostDepth + (
          hasGhostSubtree ? 1 : 0
        ) | 0, subjs.hd),
        tl: Stdlib__List.map((function (param) {
          return loop(ghostDepth, param);
        }), subjs.tl)
      }) : /* [] */ 0;
    const post = children ? children.hd.pre : null;
    return {
      name: name,
      arg: arg,
      result: result,
      ghostDepth: ghostDepth,
      hasGhostSubtree: hasGhostSubtree,
      regexId: Js__Js_nullable.fromOption(regex_id),
      redundant: redundant,
      pre: pre,
      post: post,
      children: Stdlib__Array.of_list(children)
    };
  };
  if (/* tag */ typeof tree_node === "number" || typeof tree_node === "string") {
    if (tree_node !== /* Mismatch */ 0) {
      return make("Match", undefined, "Match", "", /* [] */ 0);
    }
    const match$1 = fail_label(ann.acts);
    return make("Mismatch", undefined, match$1[0], match$1[1], /* [] */ 0);
  } else {
    switch (tree_node.TAG) {
      case /* Choice */ 0 :
        return make(undefined, undefined, "Choice", "", {
          hd: tree_node._0,
          tl: {
            hd: tree_node._1,
            tl: /* [] */ 0
          }
        });
      case /* Read */ 1 :
        return make(undefined, undefined, "Read ", quote_char(Melange__RegexRender.Pp.char_text(tree_node._0)), {
          hd: tree_node._1,
          tl: /* [] */ 0
        });
      case /* ReadBackRef */ 2 :
        const text = Stdlib__String.concat("", Stdlib__List.map(Melange__RegexRender.Pp.char_text, tree_node._0));
        return make(undefined, undefined, "BackRef ", quote_str(text), {
          hd: tree_node._1,
          tl: /* [] */ 0
        });
      case /* Progress */ 3 :
        return make(undefined, undefined, "Progress", "", {
          hd: tree_node._0,
          tl: /* [] */ 0
        });
      case /* AnchorPass */ 4 :
        return make(undefined, undefined, "Anchor ", Melange__RegexRender.Pp.anchor_text(tree_node._0), {
          hd: tree_node._1,
          tl: /* [] */ 0
        });
      case /* GroupAction */ 5 :
        const match$2 = group_label(tree_node._0);
        return make(undefined, undefined, match$2[0] + " ", match$2[1], {
          hd: tree_node._1,
          tl: /* [] */ 0
        });
      case /* LK */ 6 :
        return make(undefined, true, lk_name(tree_node._0), "", {
          hd: tree_node._1,
          tl: {
            hd: tree_node._2,
            tl: /* [] */ 0
          }
        });
      case /* LKFail */ 7 :
        return make("Mismatch", true, lk_name(tree_node._0), "", {
          hd: tree_node._1,
          tl: /* [] */ 0
        });
      case /* Annot */ 8 :
        throw new Caml_js_exceptions.MelangeError("Assert_failure", {
            MEL_EXN_ID: "Assert_failure",
            _1: [
              "TreeConvert.ml",
              179,
              5
            ]
          });
    }
  }
}

function to_tree(idMap, input, t) {
  if (/* tag */ typeof t === "number" || typeof t === "string") {
    throw new Caml_js_exceptions.MelangeError("Assert_failure", {
        MEL_EXN_ID: "Assert_failure",
        _1: [
          "TreeConvert.ml",
          185,
          9
        ]
      });
  }
  if (t.TAG === /* Annot */ 8) {
    return to_node(idMap, input, {
      contents: /* [] */ 0
    }, false, t._0, 0, t);
  }
  throw new Caml_js_exceptions.MelangeError("Assert_failure", {
      MEL_EXN_ID: "Assert_failure",
      _1: [
        "TreeConvert.ml",
        185,
        9
      ]
    });
}

const debug = false;

const matched = "Match";

const mismatched = "Mismatch";

export {
  debug,
  same,
  regex_id_of,
  same_regex,
  same_action,
  same_actions,
  same_match_state,
  quote_char,
  quote_str,
  matched,
  mismatched,
  dir_str,
  lk_name,
  group_label,
  fail_label,
  state_js,
  unwrap,
  check_seen,
  to_node,
  to_tree,
}
/* BigInt Not a pure module */
